import React, { Fragment } from 'react';
import { format } from 'date-fns';
import { DetailsButton, DetailsCell, DotPlaceholder, NameCell, UnseenDot, ValueCell } from './ReviewItem.styles';
import { useSelector } from 'react-redux';
import { selectUser } from '../../../../store/slices/user/slice';
import { CRM_ORGANIZATION_MEMBER_ROLE } from '../../../../utils/constants';

const ReviewItem = ({ chatter, reviewer, createdAt, seen, onDetailsClicked }) => {
  const user = useSelector(selectUser);
  const isNotReviewer = user.role !== CRM_ORGANIZATION_MEMBER_ROLE.REVIEWER;
  const unseen = isNotReviewer && !seen;

  return (
    <Fragment>
      <NameCell $unseen={unseen}>
        {unseen ? <UnseenDot aria-label="Unseen" /> : <DotPlaceholder aria-hidden />}
        <p>{chatter.name || '-'}</p>
      </NameCell>
      <ValueCell $unseen={unseen}>
        <p>{reviewer.name || '-'}</p>
      </ValueCell>
      <ValueCell $unseen={unseen}>
        <p>{createdAt ? format(new Date(createdAt), 'd.MM.yyyy HH:mm') : '-'}</p>
      </ValueCell>
      <DetailsCell>
        <DetailsButton
          type="button"
          onClick={event => {
            event.stopPropagation();
            onDetailsClicked?.();
          }}>
          Details
        </DetailsButton>
      </DetailsCell>
    </Fragment>
  );
};

export default ReviewItem;
